import { DataField, H2 } from "../../components/common-components";

export const InterventionPatientSections = ({ clinicalServiceName = "", documentation = {} }) => {
  const provider = documentation?.notificationInformations && documentation.notificationInformations.length > 0
    ? documentation.notificationInformations[0]
    : null;

  const providerName = provider
    ? [provider.lastName, provider.firstName, provider.middleName].filter(Boolean).join(' ')
    : "";

  const designation = provider?.designation || provider?.title || "";

  const phone = provider?.phoneNumber || provider?.telephone || provider?.primaryPhone || "";
  const email = provider?.emailAddress || provider?.email || "";
  const licence = provider?.licenseNumber || provider?.license || provider?.licenceNumber || "";
  const displayClinicalServiceName = clinicalServiceName?.trim() || "Patient Chart";
  return (
    <div className="space-y-0">
      <div className="flex bg-gray-10 border border-gray-100">
        <div className="flex-1 py-2">
          <div className="px-4">
            <div className="space-y-1">
              <DataField
                label="Name of Service:"
                value={displayClinicalServiceName}
              />
              <DataField
                label="To"
                value={providerName || designation || ""}
              />
              <p className="text-xs">
                <span className="font-semibold">After an assessment for : </span>
                <span className="font-semibold">[{displayClinicalServiceName}]</span>
                <span>, a drug therapy problem was identified.</span>
              </p>
            </div>
          </div>
        </div>

        <div className="w-px bg-gray-200 my-4"></div>

        <div className="flex-1 py-2">
          <div className="px-4">
            <H2>Prescriber Information</H2>
            <div className="space-y-1">
              <DataField
                label="Primary Phone number"
                value={phone}
              />
              <DataField
                label="Email Address"
                value={email}
              />
              <DataField
                label="Licence Number"
                value={licence}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
